import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-checkbox-list',
  templateUrl: './checkbox-list.component.html',
  styles: [],
})
export class CheckboxListComponent {
  @Input() items: string[] = [];
  @Input() selectedItems: string[] = [];
  @Output() selectionChange = new EventEmitter<string[]>();

  toggleCheckbox(item: string): void {
    if (this.selectedItems.includes(item)) {
      this.selectedItems = this.selectedItems.filter((i) => i !== item);
    } else {
      this.selectedItems.push(item);
    }

    this.selectionChange.emit(this.selectedItems);
  }
}
